export default __webpack_public_path__ + "static/media/hydration@3x.11bcce75.jpg";